import { isAxiosError } from 'axios';

export const getErrorMessage = (error: unknown, fallback = 'Something went wrong. Try again.') => {
  if (!isAxiosError(error)) return fallback;

  const data = error.response?.data as { message?: unknown; details?: unknown } | undefined;
  const details = Array.isArray(data?.details) ? data.details.filter((d) => typeof d === 'string') : [];
  if (details.length > 0) return details.join('. ');
  if (typeof data?.details === 'string' && data.details) return data.details;
  if (typeof data?.message === 'string' && data.message) return data.message;
  if (error.response?.status === 413) return 'The file is too large. Images must be under 2 MB.';
  return fallback;
};
